module.exports = __webpack_public_path__ + "static/media/Core Modules Demo Outline & Script-v3_ForAssoc_1592835278129.f518aef4.Studios";